import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { HelpdeskAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/helpdesk/helpdesk-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const HelpdeskAccessRulesConst: Record<HelpdeskAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль HELPDESK ---
  // --- Раздел HELPDESK.SECTIONS.HELPDESK ---

  // Вкладки
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_READ]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TASK.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_WRITE]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TASK.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_TYPE_READ]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TASK_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TASK_TYPE_WRITE]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TASK_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TEMPLATE_READ]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_TEMPLATE_WRITE]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EMAIL_SETTINGS_READ]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.EMAIL_SETTINGS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EMAIL_SETTINGS_WRITE]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.EMAIL_SETTINGS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_FIELDS_SETTINGS_READ]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.FIELDS_SETTINGS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_FIELDS_SETTINGS_WRITE]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.tabs.FIELDS_SETTINGS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EAV_ENTITY_TYPE_READ]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.EAV_ENTITY_TYPE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EAV_ENTITY_TYPE_WRITE]: {
    'BASIS.enabled': true,
    'BASIS.sections.CATALOG.tabs.EAV_ENTITY_TYPE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_READ_ALL_TASKS]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.READ_ALL_TASKS.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_EDIT_OTHER_USERS_TASKS]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.EDIT_OTHER_USERS_TASKS.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DELETE_TASKS]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.DELETE_TASKS.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DELETE_OTHER_USER_COMMENTS]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.DELETE_OTHER_USER_COMMENTS.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_ANSWER_WITH_AI]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.ANSWER_WITH_AI.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_DETERMINE_BEST_ANSWER]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.DETERMINE_BEST_ANSWER.isAllowed': true
  },
  [HelpdeskAccessRulesKeyEnum.HELPDESK_HELPDESK_MERGE_HD_TASKS]: {
    'HELPDESK.enabled': true,
    'HELPDESK.sections.HELPDESK.permissions.MERGE_HD_TASKS.isAllowed': true
  }
};
